import React, { useState, useRef, useEffect } from "react";
import "./PrintType7/PrintType7.scss";
import commaSeparator, {
  formatToPersianAddComma,
} from "../../utils/CommaSeparator";
import numericFunction from "../../utils/NumericFunction";
import NumericFunction from "../../utils/NumericFunction";
import Barcode from "react-barcode";
import PrintType7Header2 from "./PrintType7/PrintType7Header2";
import PrintType7Footer2 from "./PrintType7/PrintType7Footer2";

const PrintLedger = ({ data }) => {
  let totalClassName = "printType7";
  if (data.entityName === "FAKKOLSELL") {
    totalClassName = "bill8cmPrint";
  }
  const [page, setPage] = useState(0);
  let myColumns = data.column;
  let myData = data.data;
  let fieldColumns = [];

  myColumns.forEach((myColumn) => {
    fieldColumns.push(myColumn.field);
  });
  let date = new Date();

  // Simple format
  date = new Intl.DateTimeFormat("fa-IR").format(date);
  const style = `
  @page {
    size: A4;
    padding: 0.5cm !important;
    margin: 0.5cm !important;
    counter-increment: page;
    counter-reset: page 1;
  } 
`;
  const printContentRef = useRef(null);
  let index = 0;
  useEffect(() => {
    const currentPageIndex = Math.floor(index / 20) + 1;
    setPage(currentPageIndex);
  }, [index]);

  const uniqueAccountNames = [
    ...new Set(myData?.map((item) => item.accountName)),
  ];
  const titles = uniqueAccountNames.filter((item) => item !== "");
  console.log(titles);
  return (
    <div className="print-content" ref={printContentRef}>
      <style>{style}</style>

      <div
        className={totalClassName}
        style={{ margin: "0 10px", fontSize: "12px" }}
      >
        <table>
          <thead>
            <tr style={{ height: "40px" }}>
              <td colSpan={myColumns.length}>
                <PrintType7Header2
                  date={date}
                  name={data.name}
                  company={data.companyName}
                />
              </td>
            </tr>
            <tr style={{ minHeight: "25px", height: "25px" }}>
              {myColumns?.map((v, index) => (
                <td key={"R" + index}>{v.title}</td>
              ))}
            </tr>
          </thead>

          <tbody>
            {myData.map((singleRowData, index) =>
              index > 3 &&
              data.title === "general" &&
              index !== myData.length - 1 &&
              myData[index - 2]["accountName"] !==
                myData[index + 1]["accountName"] &&
              myData[index - 2]["accountName"] !== "" &&
              myData[index + 1]["accountName"] !== "" ? (
                <tr
                  id={singleRowData.id}
                  key={"R" + index}
                  style={{ minHeight: "43.5px", height: "43.5px" }}
                  className="goNextPage"
                >
                  {fieldColumns.map((field, indexField) => {
                    //اگه کد کالا بود سه رقم جدا نشه کلید CKALA
                    if (
                      singleRowData[field] === "" ||
                      field === "CKALA" ||
                      field === "row"
                    ) {
                      return (
                        <td key={indexField}>
                          {numericFunction.e2p(singleRowData[field]) + ""}
                        </td>
                      );
                    } else {
                      return (
                        <td key={indexField}>
                          {/*{(numericFunction.e2p(singleRowData[field] + ""))}*/}
                          {formatToPersianAddComma(singleRowData[field])}

                          {/*{singleRowData[field]}*/}
                        </td>
                      );
                    }
                  })}
                </tr>
              ) : (
                <tr
                  id={singleRowData.id}
                  key={"R" + index}
                  style={{ minHeight: "43.5px", height: "43.5px" }}
                >
                  {fieldColumns.map((field, indexField) => {
                    //اگه کد کالا بود سه رقم جدا نشه کلید CKALA
                    if (
                      singleRowData[field] === "" ||
                      field === "CKALA" ||
                      field === "row"
                    ) {
                      return (
                        <td key={indexField}>
                          {numericFunction.e2p(singleRowData[field]) + ""}
                        </td>
                      );
                    } else {
                      return (
                        <td key={indexField}>
                          {/*{(numericFunction.e2p(singleRowData[field] + ""))}*/}
                          {formatToPersianAddComma(singleRowData[field])}

                          {/*{singleRowData[field]}*/}
                        </td>
                      );
                    }
                  })}
                </tr>
              )
            )}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={myColumns.length}>
                <PrintType7Footer2 data={page} />
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default PrintLedger;
